import { Injectable } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { DefaultUrlSerializer } from '@angular/router';

import { addSlashToEndOfPathnameInUrl, encodeSinglePercentCharacterInGetParams } from './helpers';

@Injectable()
export class WrikeUrlSerializer extends DefaultUrlSerializer {
    public parse(url: string): UrlTree {
        const safeUrl = encodeSinglePercentCharacterInGetParams(url);
        return super.parse(safeUrl);
    }

    public serialize(tree: UrlTree): string {
        const url = super.serialize(tree);
        return addSlashToEndOfPathnameInUrl(url);
    }
}
